import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from '../molecules';
import { VehicleCard } from '../molecules';

const VehicleLineupSection = ({ type = 'vip', className = "" }) => {
  const { t } = useTranslation();

  // VIP車両データ
  const vipVehicles = [
    {
      title: t('serviceDetail.vipCar.vehicles.types.0.title'),
      capacity: t('serviceDetail.vipCar.vehicles.types.0.subtitle'),
      description: t('serviceDetail.vipCar.vehicles.types.0.description'),
      hourlyRate: "15,000",
      features: t('serviceDetail.vipCar.vehicles.types.0.features', { returnObjects: true })
    },
    {
      title: t('serviceDetail.vipCar.vehicles.types.1.title'),
      capacity: t('serviceDetail.vipCar.vehicles.types.1.subtitle'),
      description: t('serviceDetail.vipCar.vehicles.types.1.description'),
      hourlyRate: "12,000",
      features: t('serviceDetail.vipCar.vehicles.types.1.features', { returnObjects: true })
    },
    {
      title: t('serviceDetail.vipCar.vehicles.types.2.title'),
      capacity: t('serviceDetail.vipCar.vehicles.types.2.subtitle'),
      description: t('serviceDetail.vipCar.vehicles.types.2.description'),
      hourlyRate: "18,000",
      features: t('serviceDetail.vipCar.vehicles.types.2.features', { returnObjects: true })
    }
  ];

  // バス車両データ（タイ語翻訳から取得）
  const busVehicles = [
    {
      title: "รถบัสท่องเที่ยวขนาดใหญ่",
      capacity: "45-60 คน",
      description: "เหมาะสำหรับทัวร์กลุ่มและการฝึกอบรมของบริษัท รองรับการเดินทางระยะไกลที่สะดวกสบาย",
      price: "ตั้งแต่ 80,000 เยนต่อวัน",
      features: [
        "เบาะปรับเอนได้",
        "มีเครื่องปรับอากาศ",
        "มีห้องน้ำ",
        "อุปกรณ์ DVD และไมโครโฟน",
        "มี Wi-Fi"
      ]
    },
    {
      title: "รถบัสขนาดกลาง",
      capacity: "25-35 คน",
      description: "เป็นที่นิยมสำหรับกลุ่มขนาดกลาง ผสมผสานความคล่องตัวและความสะดวกสบาย",
      price: "ตั้งแต่ 60,000 เยนต่อวัน",
      features: [
        "เบาะท่องเที่ยว",
        "มีเครื่องปรับอากาศ",
        "อุปกรณ์ไมโครโฟน",
        "ห้องเก็บสัมภาระ",
        "พอร์ตชาร์จ USB"
      ]
    },
    {
      title: "ไมโครบัส",
      capacity: "15-25 คน",
      description: "เหมาะสำหรับกลุ่มเล็กและการเดินทางระยะสั้น ปลอดภัยในการขับขี่บนถนนแคบ",
      price: "ตั้งแต่ 45,000 เยนต่อวัน",
      features: [
        "เบาะกว้างขวาง",
        "มีเครื่องปรับอากาศ",
        "ห้องเก็บสัมภาระขนาดใหญ่",
        "การออกแบบที่ขึ้นลงง่าย"
      ]
    },
    {
      title: "รถตู้ไฮเอซ",
      capacity: "8-15 คน",
      description: "สำหรับกลุ่มเล็กและทัวร์ส่วนตัว ให้บริการที่ละเอียดและเอาใจใส่",
      price: "ตั้งแต่ 25,000 เยนต่อวัน",
      features: [
        "เบาะปรับเอนได้",
        "การควบคุมอุณหภูมิแบบแยกส่วน",
        "พื้นที่เก็บสัมภาระขนาดใหญ่",
        "ติดตั้ง Wi-Fi"
      ]
    }
  ];

  const vehicles = type === 'vip' ? vipVehicles : busVehicles;
  const sectionData = type === 'vip' ? {
    badge: t('serviceDetail.vipCar.vehicles.badge'),
    title: t('serviceDetail.vipCar.vehicles.title'),
    subtitle: t('serviceDetail.vipCar.vehicles.subtitle')
  } : {
    badge: "รายการยานพาหนะ",
    title: "ยานพาหนะที่ปรับให้เข้ากับความต้องการของคุณ",
    subtitle: "รองรับทุกขนาดตั้งแต่ 1 ถึง 200 คน"
  };

  return (
    <section className={`py-16 bg-gray-50 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          badge={sectionData.badge}
          title={sectionData.title}
          subtitle={sectionData.subtitle}
          className="text-center mb-12"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {vehicles.map((vehicle, index) => (
            <VehicleCard
              key={index}
              vehicle={vehicle}
              type={type}
              className="h-full"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default VehicleLineupSection;
